import _ from "lodash";
import { api } from "../../server/request";
import { handleError, handleResponse, handleResponseObj } from "../../actions/responseUtil";
import { toast } from "react-toastify";

export const ACTION_TYPES = {
    SET_LOADING: "starlinkPooled/setLoading",
    GET_POOLED_USAGE_PIE: "starlinkPooled/getPooledUsagePie",
    GET_POOLED_USAGE_BAR_CHART: "starlinkPooled/getPooledUsageBarChart",
    GET_POOLED_USAGE_TOP_CARDS: "starlinkPooled/getPooledUsageTopCards",
    GET_POOLED_USAGE_LINE_CHART: "starlinkPooled/getPooledUsageLineChart",
    GET_POOLED_USAGE_TABLE: "starlinkPooled/getPooledUsageTable",
    GET_POOLED_USAGE_PIE_SPLIT: "starlinkPooled/getPooledUsagePieSplit",
     GET_STARLINK_PLAN_TEMPLATE: "starlinkPooled/getStarlinkPlanTemplate",
     CREATE_PLAN_TEMPLATE: "starlinkPooled/createPlanTemplate",
     GET_STARLINK_PLAN_HIERARCHY: "starlinkPooled/getStarlinkPlanHierarchy",
     ASSIGN_CUSTOM_PLAN: "starlinkPooled/assignCustomPlan",
     ASSIGN_CHILD_POOL: "starlinkPooled/assignChildPool",
     GET_SERVICE_LINE_PER_PLAN: "starlinkPooled/getServiceLinePerPlan",
     GET_SERVICE_LINE_PER_PLAN_RIGHT:"starlinkPooled/getServicePlanPerPlanRight",
     MOVE_SERVICE_PLAN:"starlinkPooled/moveServicePlan",
     GET_SERVICE_PLAN_TOP_WIDGET: "starlinkPooled/getServicePlanTopWidget",
     DELETE_CUSTOM_PLAN: "starlinkPooled/deleteCustomPlan",
     DELETE_PLAN_TEMPLATE: "starlinkPooled/deletePlanTemplate",
     DELETE_CHILD_POOL: "starlinkPooled/deleteChildPool",
     EDIT_PLAN_TEMPLATE: "starlinkPooled/editPlanTemplate",
     TRACK_SERVICE_PLAN_MOVEMENT: "starlinkPooled/trackServicePlanMovement",
}

const initialState = {
    pooledUsagePie: [],
    pooledBarChart: [],
    pooledTopCards: [],
    pooledLineChart: [],
    pooledTable: [],
    pooledUsagePieSplit: [],
    gettingPooledUsagePie: false,
    gettingPooledBarChart: false,
    gettingPooledTopCards: false,
    gettingPooledlineChart: false,
    gettingPooledTable: false,
    gettingPooledUsagePieSplit: false,
    creatingPlanTemplate: false,
    movingServicePlan: false,
    createPlanTemplate: [],
    editPlanTemplate: [],
    starlinkPlanTemplate: [],
    starlinkPlanHierarchy:[],
    assignCustomPlanToPool: [],
    assignChildPool:[],
    serviceLinePlans:[],
    serviceLinePlansRight:[],
    servicePlanTopWidget: [],
     deletingCustomPlan: null,
    deleteCustomPlan: null,
    deletePlanTemplate: null,
    deleteChildPool: null,
    updatingStandardPlanAlias: false,
    updatePlanAlias:null,
    trackServicePlanMovement: [],
    trackLoading: false,
}

export function starlinkPooledReducer(state: any = initialState, action) {
    switch (action.type) {
        case ACTION_TYPES.GET_POOLED_USAGE_PIE: {
            return {
                ...state,
                pooledUsagePie: action.payload?.data,
            }
        }
        case ACTION_TYPES.GET_POOLED_USAGE_BAR_CHART: {
            return {
                ...state,
                pooledBarChart: action.payload?.data,
            }
        }
         case ACTION_TYPES.DELETE_CUSTOM_PLAN: {
                    return {
                        ...state,
                        deleteCustomPlan: action.payload
                    }
                }
          case ACTION_TYPES.DELETE_PLAN_TEMPLATE: {
                    return {
                        ...state,
                        deletePlanTemplate: action.payload
                    }
                }
          case ACTION_TYPES.DELETE_CHILD_POOL: {
                    return {
                        ...state,
                        deleteChildPool: action.payload
                    }
                }
        case ACTION_TYPES.GET_POOLED_USAGE_TOP_CARDS: {
            return {
                ...state,
                pooledTopCards: action.payload,
            }
        }
        case ACTION_TYPES.GET_POOLED_USAGE_LINE_CHART: {
            return {
                ...state,
                pooledLineChart: action.payload?.data,
            }
        }
        case ACTION_TYPES.GET_POOLED_USAGE_TABLE: {
            return {
                ...state,
                pooledTable: action.payload?.data,
            }
        }
        case ACTION_TYPES.GET_POOLED_USAGE_PIE_SPLIT: {
            return {
                ...state,
                pooledUsagePieSplit: action.payload?.data,
            }
        }
        case ACTION_TYPES.GET_STARLINK_PLAN_TEMPLATE: {
            return {
                ...state,
                starlinkPlanTemplate: action.payload?.data,
            }
        }
        case ACTION_TYPES.GET_STARLINK_PLAN_HIERARCHY: {
            return {
                ...state,
                starlinkPlanHierarchy: action.payload?.data,
            }
        }
        case ACTION_TYPES.GET_SERVICE_LINE_PER_PLAN: {
            return {
                ...state,
                serviceLinePlans: action.payload?.data,
            }
        }
        case ACTION_TYPES.GET_SERVICE_LINE_PER_PLAN_RIGHT: {
            return {
                ...state,
                serviceLinePlansRight: action.payload?.data,
            }
        }
        case ACTION_TYPES.TRACK_SERVICE_PLAN_MOVEMENT: {
            return {
                ...state,
                trackServicePlanMovement: action.payload?.data,
            }
        }
        case ACTION_TYPES.CREATE_PLAN_TEMPLATE: {
            return {
                ...state,
                createPlanTemplate: action.payload,
            }
        }
            case ACTION_TYPES.EDIT_PLAN_TEMPLATE: {
            return {
                ...state,
                editPlanTemplate: action.payload,
            }
        }
        case ACTION_TYPES.ASSIGN_CUSTOM_PLAN: {
            return {
                ...state,
                assignCustomPlanToPool: action.payload,
            }
        }
        case ACTION_TYPES.MOVE_SERVICE_PLAN: {
            return {
                ...state,
                moveServicePlan: action.payload,
            }
        }
        case ACTION_TYPES.ASSIGN_CHILD_POOL: {
            return {
                ...state,
                assignChildPool: action.payload,
            }
        }
        case ACTION_TYPES.GET_SERVICE_PLAN_TOP_WIDGET: {
            return {
                ...state,
                servicePlanTopWidget: action.payload?.data && action.payload?.data?.length > 0 ? action.payload?.data[0] : {},
            }
        }
        case ACTION_TYPES.SET_LOADING: {
            return {
                ...state,
                ...action.payload
            }
        }
        default:
            return state
    }
}

export interface getPooledUsageParameters {
    dpId: string;
    chartStartDate: string;
    chartEndDate: string;
    limit: number;
    offset: number;
    searchText: string;
    sortBy: string;
    sortOrder: string;
    source: string;
    accounts: string[];
    usageSource:string
}

export const getPooledUsageTable = (parameters: getPooledUsageParameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledTable: true } });
    let _parameters = {
        dpId: parameters.dpId,
        chartStartDate: parameters.chartStartDate,
        chartEndDate: parameters.chartEndDate,
        limit: parameters.limit,
        offset: (parameters.offset - 1) * parameters.limit,
        searchText: parameters.searchText,
        sortBy: parameters.sortBy,
        sortOrder: parameters.sortOrder,
        accounts: parameters?.accounts?.map(acc => `'${acc}'`).join(',')
    };
    const data = {
        query: parameters.source == 'aggregation_table' ? 'GET_STARLINK_ORGANIZATION_USAGE_AGG_CH' : `GET_STARLINK_ORGANIZATION_USAGE_DIRECT_CH`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_POOLED_USAGE_TABLE)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledTable: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledTable: false } });
        });
}

export const getPooledUsagePie = (parameters: getPooledUsageParameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePie: true } });
    let _parameters = {
        dpId: parameters.dpId,
        chartStartDate: parameters.chartStartDate,
        chartEndDate: parameters.chartEndDate,
        limit: parameters.limit,
        offset: parameters.offset,
        source: parameters?.source,
        accounts: parameters?.accounts?.map(acc => `'${acc}'`).join(','),
    };
    const data = {
        query: `GET_STARLINK_ORGANIZATION_USAGE_PIE_CH`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_POOLED_USAGE_PIE)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePie: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePie: false } });
        });
}

export const getPooledBarChart = (parameters: getPooledUsageParameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledBarChart: true } });
    let _parameters = {
        dpId: parameters.dpId,
        chartStartDate: parameters.chartStartDate,
        chartEndDate: parameters.chartEndDate,
        source: parameters.source,
        limit: parameters.limit,
        offset: parameters.offset,
        accounts: parameters?.accounts?.map(acc => `'${acc}'`).join(',')
    };

    const data = {
        query: `GET_STARLINK_ORGANIZATION_USAGE_STACKED_CHART_CH`,
        named: true,
        format: 'chart',
        groupBy: "organizationName",
        tsColumn: "date",
        series: "chartUsage",
        annotation: "asset_name",
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_POOLED_USAGE_BAR_CHART)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledBarChart: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledBarChart: false } });
        });
}

export const getPooledTopCards = (parameters: getPooledUsageParameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledTopCards: true } });
    let _parameters = {
        dpId: parameters.dpId,
        accounts: parameters?.accounts?.map(acc => `'${acc}'`).join(','),
    };

    const data = {
        query: `GET_STARLINK_ORGANIZATION_USAEGE_TOPCARD`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_POOLED_USAGE_TOP_CARDS)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledTopCards: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledTopCards: false } });
        });
}

export const getPooledLineChart = (parameters: getPooledUsageParameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledLineChart: true } });
    let _parameters = {
        dpId: parameters.dpId,
        accounts: parameters?.accounts?.map(acc => `'${acc}'`).join(','),
        chartStartDate: parameters?.chartStartDate,
        chartEndDate: parameters?.chartEndDate,
        usageSource: parameters?.usageSource
    };

    const data = {
        query: `GET_STARLINK_ORGANIZATION_USAGE_BURNOUT_CH`,
        named: true,
        format: 'chart',
        groupBy: "usage_type",
        tsColumn: "date",
        series: "usage_value",
        annotation: "asset_name",
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_POOLED_USAGE_LINE_CHART)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledLineChart: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledLineChart: false } });
        });
}

export const getPooledUsagePieSplit = (parameters: any) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: true } });
    let _parameters = {
        dpId: parameters.dpId,
        limit: parameters.limit,
        offset: parameters.offset,
        accounts: parameters?.accounts?.map(acc => `'${acc}'`).join(','),
    };
    const data = {
        query: `GET_STARLINK_ORGANIZATION_USAGE_SPLIT_PIE_CH`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/ch/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_POOLED_USAGE_PIE_SPLIT)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        });
}

export const getStarlinkTemplate = (parameters: any) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: true } });
    let _parameters = {
        dpId: parameters.dpId,
        plan_filter: parameters.plan_filter,
         search: parameters.searchValue
    };
    const data = {
        query: `GET_STARLINK_PLAN_TEMPLATES`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_PLAN_TEMPLATE)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        });
}

export const getStarlinkPlanHierarchy = (parameters: any) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: true } });
    let _parameters = {
        dp_id: parameters.dpId,
        plan_filter: parameters.plan_filter,
        search: parameters.searchValue
    };
    const data = {
        query: `STARLINK_GET_PLAN_HIERARCHY_V3`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_STARLINK_PLAN_HIERARCHY)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        });
}

export const getServiceLinePerPlan = (parameters: any) => (dispatch) => {
    if(_.isEmpty(parameters.plan_type) || _.isEmpty(parameters.account_number)) return
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: true } });
    let _parameters = {
        dp_id: parameters.dp_id,
        custom_plan_id: parameters.custom_plan_id,
        org_filter: "",
        plan_type: parameters?.plan_type,
        product_reference_id: parameters?.product_reference_id,
        search: parameters?.search,
        page_limit: parameters?.page_limit,
        page_offset: parameters?.page_offset,
        account_number: parameters?.account_number
    };
    const data = {
        query: `GET_STARLINK_ASSIGNED_SERVICE_LINES_V3`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_LINE_PER_PLAN)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        });
}

export const getServiceLinePerPlanRight = (parameters: any) => (dispatch) => {
    if(_.isEmpty(parameters.plan_type) || _.isEmpty(parameters.account_number)) return
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: true } });
    let _parameters = {
        dp_id: parameters.dp_id,
        custom_plan_id: parameters.custom_plan_id,
        org_filter: "",
        plan_type: parameters?.plan_type,
        product_reference_id: parameters?.product_reference_id,
        search: parameters?.search,
        page_limit: parameters?.page_limit,
        page_offset: parameters?.page_offset,
        account_number: parameters?.account_number
    };
    const data = {
        query: `GET_STARLINK_ASSIGNED_SERVICE_LINES_V3`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_LINE_PER_PLAN_RIGHT)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        });
}


export const trackMoveServicePlan = (parameters: any) => (dispatch) => {
    if(_.isEmpty(parameters.dp_id)) return
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { trackLoading: true } });
    let _parameters = {
        dp_id: parameters.dp_id,
    };
    const data = {
        query: `STARLINK_GET_BULK_MOVEMENT_STATUS_DETAILS`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.TRACK_SERVICE_PLAN_MOVEMENT)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { trackLoading: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { trackLoading: false } });
        });
}
export const clearTrackAPI = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.TRACK_SERVICE_PLAN_MOVEMENT, payload: [] })
}

export const clearMoveServicePlan = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.MOVE_SERVICE_PLAN, payload: [] })
}

export const showToastMessage = (res, handler) => {
   if(res.success == false) {
    toast.error(`${handler} : ${res.message}, Please try after sometime.`, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
   } else {
    toast.success(res.message, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
   }
}


export const createTemplate = (parameters) => (dispatch) => {
    if (!parameters?.dpId) return;
    
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: true } });
  
    return api.starlink.post(`/planTemplate`, parameters, {})
      .then((res) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        dispatch({ type: ACTION_TYPES.CREATE_PLAN_TEMPLATE, payload: res });
        showToastMessage(res, 'Plan Template Created Successfully');
        return res;
      })
      .catch((error) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        return error;
      });
  };
  

  export const editTemplate = (parameters) => (dispatch) => {
    if (!parameters?.dpId) return;
    
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: true } });
  
    return api.starlink.put(`/planTemplate/${parameters?.templateId}`, parameters, {})
      .then((res) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        dispatch({ type: ACTION_TYPES.EDIT_PLAN_TEMPLATE, payload: res });
        showToastMessage(res, 'Plan Template updated successfully');
        return res;
      })
      .catch((error) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        return error;
      });
  };
  


  export const assignCustomPlanAPI = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: true } });
  
    return api.starlink.post(`/customPlans`, parameters, {})
      .then((res) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        dispatch({ type: ACTION_TYPES.ASSIGN_CUSTOM_PLAN, payload: res });
        showToastMessage(res, 'Plan Assigned Successfully');
        return res;
      })
      .catch((error) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        return error;
      });
  };
  

  export const assignChildPoolAPI = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: true } });
  
    return api.starlink.post(`/parentPools/${parameters?.parentPoolId}/childPools`, parameters, {})
      .then((res) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        dispatch({ type: ACTION_TYPES.ASSIGN_CHILD_POOL, payload: res });
        showToastMessage(res, 'Pool Assigned Successfully');
        return res;
      })
      .catch((error) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { creatingPlanTemplate: false } });
        return error;
      });
  };

  export const moveServicePlanAPI = (parameters) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { movingServicePlan: true } });
  
    return api.starlink.put(`/service_lines/move_service_plan`, parameters, {})
      .then((res) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { movingServicePlan: false } });
        dispatch({ type: ACTION_TYPES.MOVE_SERVICE_PLAN, payload: res });
        showToastMessage(res, '');
        return res;
      })
      .catch((error) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { movingServicePlan : false } });
        dispatch({ type: ACTION_TYPES.MOVE_SERVICE_PLAN, payload: [{success: false, message: "Error in moving service lines", data: []}] });
        showToastMessage({success: false, message: "Error in moving service lines"}, '');
        return error;
      });
  };

  export const deleteCustomPlanAPI = (parameters) => async (dispatch) => {
    const { customPlanId, customPlanName } = parameters;

    if (_.isEmpty(customPlanId)) return;

    dispatch({
        type: ACTION_TYPES.SET_LOADING,  payload: { deletingCustomPlan: true }
    });

    try {
        const res = await api.starlink.delete(`/customPlans/${customPlanId}` );

        if(res){
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingCustomPlan: false }  });
              handleResponseObj(res, dispatch, ACTION_TYPES.DELETE_CUSTOM_PLAN)
        }

        showToastMessage(res, ` ${customPlanName} Plan Deleted Successfully`);
        return res;
    } catch (error) {
        dispatch({   type: ACTION_TYPES.SET_LOADING,payload: { deletingCustomPlan: false }
        });
        return null;
    }
};

//available_products/name

  export const deleteTemplateAPI = (parameters) => async (dispatch) => {
    const { templateId, templateName } = parameters;

    if (_.isEmpty(templateId)) return;

    dispatch({
        type: ACTION_TYPES.SET_LOADING,  payload: { deletingCustomPlan: true }
    });

    try {
        const res = await api.starlink.delete(`/planTemplate/${templateId}` );

        if(res){
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingCustomPlan: false }  });
              handleResponseObj(res, dispatch, ACTION_TYPES.DELETE_PLAN_TEMPLATE)
        }

        showToastMessage(res, ` ${templateName} Template Deleted Successfully`);
        return res;
    } catch (error) {
        dispatch({   type: ACTION_TYPES.SET_LOADING,payload: { deletingCustomPlan: false }
        });
        return null;
    }
};

  export const deleteChildPoolAPI = (parameters) => async (dispatch) => {
    const { childPoolId, poolName } = parameters;

    if (_.isEmpty(childPoolId)) return;

    dispatch({
        type: ACTION_TYPES.SET_LOADING,  payload: { deletingCustomPlan: true }
    });

    try {
        const res = await api.starlink.delete(`/childPools/${childPoolId}` );

        if(res){
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { deletingCustomPlan: false }  });
              handleResponseObj(res, dispatch, ACTION_TYPES.DELETE_CHILD_POOL)
        }

        showToastMessage(res, ` ${poolName} Pool Deleted Successfully`);
        return res;
    } catch (error) {
        dispatch({   type: ACTION_TYPES.SET_LOADING,payload: { deletingCustomPlan: false }
        });
        return null;
    }
};
  
export const getStarlinkPlanTopWidget = (parameters: any) => (dispatch) => {
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: true } });
    let _parameters = {
        dp_id: parameters.dp_id,
        plan_filter: parameters.plan_filter
    };
    const data = {
        query: `GET_STARLINK_PLANS_TOP_WIDGET_V2`,
        named: true,
        format: 'json',
        parameters: _parameters
    }
    api
        .postRequestOut(`/store/pg/query`, data)
        .then((res) => {
            handleResponse(res, dispatch, ACTION_TYPES.GET_SERVICE_PLAN_TOP_WIDGET)
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        })
        .catch((err) => {
            handleError(err, dispatch);
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { gettingPooledUsagePieSplit: false } });
        });
}

export const clearComponentData = () => (dispatch) => {
    dispatch({ type: ACTION_TYPES.GET_STARLINK_PLAN_HIERARCHY, payload: { data: [] } })
    dispatch({ type: ACTION_TYPES.GET_STARLINK_PLAN_TEMPLATE, payload: { data: [] } })
}

export const updateStandardPlanAlias = (parameters) => (dispatch) => {
    if (!parameters?.organizationId) return;
    
    dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingStandardPlanAlias: true } });

    let payload = {
        organizationId: parameters?.organizationId,
        accountNumber: parameters?.accountNumber,
        productReferenceId: parameters?.productReferenceId,
        alias: parameters?.alias
    }
  
    return api.starlink.put(`/available_products/name`, payload, {})
      .then((res) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingStandardPlanAlias: false } });
        dispatch({ type: ACTION_TYPES.EDIT_PLAN_TEMPLATE, payload: res });
        showToastMessage(res, 'Plan Template updated successfully');
        return res;
      })
      .catch((error) => {
        dispatch({ type: ACTION_TYPES.SET_LOADING, payload: { updatingStandardPlanAlias: false } });
        return error;
      });
  };